export default function LocationDescription() {
    return (
        <div className="flex flex-col gap-6 md:gap-10 justify-start w-full rounded-3xl h-full">
            <div>
                <h2 className="font-bold text-2xl sm:text-3xl md:text-4xl mb-3 md:mb-4">Location & Area</h2>
                <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    Silver Trail Cabin is perfectly positioned in the heart of Washington&apos;s Cascade Mountains, near the charming town of Cle Elum. Just 90 minutes from Seattle, this location offers the ideal balance of accessibility and mountain seclusion. Whether you&apos;re seeking summer adventures or winter sports, you&apos;ll find endless opportunities right at your doorstep.
                </p>
            </div>

            <div>
                <h3 className="font-bold text-xl md:text-2xl mb-2 md:mb-3">Nearby Lakes & Water Activities</h3>
                <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    You&apos;re just minutes from pristine mountain lakes perfect for all water activities:
                </p>
                <ul className="text-base md:text-lg lg:text-xl leading-relaxed space-y-2 mt-3 ml-4">
                    <li>• <strong>Cle Elum Lake (10 min):</strong> Swimming, kayaking, fishing, boat launch</li>
                    <li>• <strong>Kachess Lake (15 min):</strong> Beach access, paddle boarding, scenic views</li>
                    <li>• <strong>Lake Easton (20 min):</strong> State park with swimming beach and boat rentals</li>
                </ul>
            </div>

            <div>
                <h3 className="font-bold text-xl md:text-2xl mb-2 md:mb-3">Winter Sports & Skiing</h3>
                <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    Winter enthusiasts will love our proximity to world-class skiing and snow activities:
                </p>
                <ul className="text-base md:text-lg lg:text-xl leading-relaxed space-y-2 mt-3 ml-4">
                    <li>• <strong>Snoqualmie Pass (30 min):</strong> 4 ski areas with 2,000+ acres of terrain</li>
                    <li>• <strong>The Summit at Snoqualmie:</strong> Night skiing, lessons, rentals available</li>
                    <li>• <strong>Cross-Country Skiing:</strong> Numerous Nordic trails in the area</li>
                    <li>• <strong>Snowshoeing:</strong> Trails accessible right from the cabin area</li>
                </ul>
            </div>

            <div>
                <h3 className="font-bold text-xl md:text-2xl mb-2 md:mb-3">Hiking & Mountain Biking</h3>
                <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    The surrounding area is a paradise for outdoor enthusiasts with endless trails:
                </p>
                <ul className="text-base md:text-lg lg:text-xl leading-relaxed space-y-2 mt-3 ml-4">
                    <li>• <strong>Rachel Lake Trail:</strong> Stunning alpine lake hike (20 min drive)</li>
                    <li>• <strong>Iron Horse Trail:</strong> 110-mile rail-trail for hiking & biking</li>
                    <li>• <strong>Hiker&apos;s Hut Trail:</strong> Family-friendly forest trail</li>
                    <li>• <strong>Mountain Biking:</strong> Extensive trail network for all skill levels</li>
                </ul>
            </div>

            <div>
                <h3 className="font-bold text-xl md:text-2xl mb-2 md:mb-3">Town of Cle Elum</h3>
                <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    Charming downtown Cle Elum offers everything you need, just 15 minutes away:
                </p>
                <ul className="text-base md:text-lg lg:text-xl leading-relaxed space-y-2 mt-3 ml-4">
                    <li>• <strong>Dining:</strong> Local restaurants, cafes, breweries, and pizza places</li>
                    <li>• <strong>Shopping:</strong> Grocery stores, gas stations, outdoor gear shops</li>
                    <li>• <strong>Services:</strong> Medical clinic, pharmacy, and essential services</li>
                    <li>• <strong>Entertainment:</strong> Local events, farmers market (summer), historic downtown</li>
                </ul>
            </div>

            <div>
                <h3 className="font-bold text-xl md:text-2xl mb-2 md:mb-3">Getting Here</h3>
                <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    Conveniently located just off I-90, our cabin is an easy and stress-free getaway:
                </p>
                <ul className="text-base md:text-lg lg:text-xl leading-relaxed space-y-2 mt-3 ml-4">
                    <li>• <strong>From Seattle:</strong> 90 minutes via I-90 East (85 miles)</li>
                    <li>• <strong>From Bellevue:</strong> 80 minutes (75 miles)</li>
                    <li>• <strong>Directions:</strong> Take I-90 East, exit at Cle Elum (detailed instructions after booking)</li>
                    <li>• <strong>Winter Driving:</strong> Chains or AWD/4WD recommended in winter. Check WSDOT for current conditions.</li>
                </ul>
            </div>

            <div className="bg-green-900 rounded-xl p-4 md:p-6">
                <h3 className="font-bold text-xl md:text-2xl mb-3">Guest Access & Privacy</h3>
                <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    You&apos;ll have exclusive access to the entire cabin and property during your stay. The 1.5-acre lot is completely private with no shared spaces. Parking for 4+ vehicles is available. Self check-in with lockbox makes arrival easy and flexible. We&apos;re available by phone/text anytime for questions or local recommendations.
                </p>
            </div>
        </div>
    )
}